import * as React from 'react';
import { cn } from '@/lib/utils';

export interface FlowerIconProps extends React.HTMLAttributes<HTMLDivElement> {
  /** アイコンの幅（px） */
  width?: number;
  /** アイコンの高さ（px） */
  height?: number;
  /** アイコンの色 */
  color?: string;
}

/**
 * FlowerIcon - 花の形をした装飾アイコン
 *
 * 4つの花びらを持つ星型の装飾アイコンです。
 * 主にタイトル周辺のデコレーションとして使用します。
 *
 * @example
 * ```tsx
 * // デフォルト
 * <FlowerIcon />
 *
 * // サイズ指定
 * <FlowerIcon width={20} height={21} />
 *
 * // 色指定
 * <FlowerIcon color="#FFFFFF" />
 *
 * // カスタムクラス
 * <FlowerIcon className="opacity-80" />
 * ```
 */
export const FlowerIcon = React.forwardRef<HTMLDivElement, FlowerIconProps>(
  (
    { className, width = 14, height = 15, color = '#FEFEFE', style, ...props },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn('inline-block', className)}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          ...style,
        }}
        {...props}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ display: 'block' }}
        >
          <path
            d="M9.22723 5.11305C8.12679 3.93352 7.37366 1.87392 7 0C6.62545 1.8743 5.87321 3.93427 4.77232 5.1138C3.67188 6.29258 1.74911 7.09927 0 7.50056C1.74955 7.9011 3.67188 8.70742 4.77232 9.88695C5.87277 11.0661 6.62589 13.1261 7.00045 15C7.37411 13.1257 8.12723 11.0657 9.22768 9.8862C10.3281 8.70705 12.2509 7.90073 14 7.49944C12.2509 7.0989 10.3281 6.29221 9.22723 5.11305Z"
            fill={color}
          />
        </svg>
      </div>
    );
  },
);

FlowerIcon.displayName = 'FlowerIcon';
